import { BaseModel, FormattedDateString, StartOfDate } from '@red/data-access';
import { Expose, Type } from 'class-transformer';

// Metadata
export class EcddActionMetadataDto extends BaseModel {
  @Expose()
  reason?: number;

  @Expose()
  approvedFile?: string;
}

export class EcddRejectedMetadataDto extends BaseModel {
  @Expose()
  reason?: number;

  @Expose()
  rejectedFile?: string;
}

// Data
export class EcddActionDataDto extends BaseModel {
  @Expose()
  @Type(() => Number)
  id!: number;

  @Expose()
  @Type(() => EcddActionMetadataDto)
  metadata?: EcddActionMetadataDto;
}

export class EcddRejectedDataDto extends BaseModel {
  @Expose()
  @Type(() => Number)
  id!: number;

  @Expose()
  @Type(() => EcddRejectedMetadataDto)
  metadata?: EcddRejectedMetadataDto;
}

// Action - Reject
export class EcddActionDto extends BaseModel {
  @Expose()
  @Type(() => EcddActionDataDto)
  ecdds?: EcddActionDataDto[];
}

export class EcddRejectedDto extends BaseModel {
  @Expose()
  @Type(() => EcddRejectedDataDto)
  ecdds?: EcddRejectedDataDto[];


}
export class EcddV2ApprovedDto extends BaseModel {
  @Expose()
  masterEcddId!: number;

  @Expose()
  ecddId!: number;

  @Expose()
  reason!: string;
}

export class EcddV2RejectedDto extends EcddV2ApprovedDto { }


export class CheckListFormDto extends BaseModel {
  @Expose()
  approved_not_approved?: string;

  @Expose()
  approving_officer_name?: string;

  @Expose()
  approving_officer_designation?: string;

  @Expose()
  yes_no_please_specify_reasons?: string;

  @Expose()
  others_5?: string;

  @Expose()
  @Type(() => Date)
  @StartOfDate()
  @FormattedDateString()
  sign_date?: string; // Use Date if you want: @Type(() => Date)

  @Expose()
  signature?: string;
}

export class EcddV2ApprovedFormCDto extends BaseModel {
  @Expose()
  masterEcddId!: number;

  @Expose()
  ecddId!: number;

  @Expose()
  customerId!: number;

  @Expose()
  checklistForm!: CheckListFormDto;

  @Expose()
  status!: string;

  @Expose()
  managementOwnershipId?: number;
}

export class EcddV2RejectedFormCDto extends EcddV2ApprovedFormCDto { }